import { GO_KINTAI } from "@/store/modules/mutation-types";
import config from "../config";

export default {
  actions: {
    async [GO_KINTAI]() {
      var url =
        config.kintai.protocol + "://" + config.kintai.server + "/#/site";
      window.open(url, "_blank");
    }
  }
};
